import { useSelector } from 'react-redux';
import { ProjectState } from 'redux/reducers/project';
import { useWorkSteps } from 'redux/reducers/worksteps';
import { RootState } from 'redux/store';

export const useRevisionedWorkSteps = (): boolean => {
  const { project } = useSelector<RootState, ProjectState>(
    (state: RootState) => state.project
  );
  const { getUnresolvedWorkSteps } = useWorkSteps();

  if (project.status !== 'review') {
    return true;
  }

  return getUnresolvedWorkSteps()?.length === 0;
};
